<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          v-if="dialog.form"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Pilih Item
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false; tosearch = ''; fetch();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
                <v-form>
                    <div class="body-2 mb-2">
                      Cari Nama Item
                    </div>

                    <v-text-field
                    v-on:keydown.enter.prevent="fetch()"
                      
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Cari Data"
  
                      hide-details
                      clearable
                      @click:clear="tosearch = ''; fetch()"
  
                      v-model="tosearch"
                      class="mb-6"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                </v-form>

              <div class="view mt-1">
                <div class="" style="height: 400px; overflow-y: auto;" v-if="!process.load">
                  <table style="border: 1px solid #ededed; width: 100%; min-height: 200px;" class="table">
                    <tr>
                      <th style="font-size: 14px; position: sticky; top: 0; background: #fff; z-index: 1; width: 60px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Aksi</th>
                      <th style="font-size: 14px; position: sticky; top: 0; background: #fff; z-index: 1; width: 100%; min-width: 100%; max-width: 100%; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Akun</th>
                    </tr>
                    <tr v-for="(items, index) in item" :key="index">
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 60px; min-width: 60px; max-width: 60px; text-align: center;">
                        <v-checkbox
                          v-model="selected"
                          color="primary"
                          hide-details
                          :value="items"
                          style="margin: 0 auto;">
                        </v-checkbox>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; min-width: 100%; max-width: 100%; border-left: none; padding: 8px 12px; text-align: left;">
                        {{ items.name }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="text-center d-flex align-center justify-center" v-else style="height: 400px">
                  <div>
                    <v-progress-circular 
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                    <div>
                      Memuat Data...
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveItem()"
                :loading="process.form"
                :disabled="process.form || selected.length < 1"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset(); tosearch = ''; fetch();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/pembelian/permintaan"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Permintaan Pembelian
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col>
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>

                            Tanggal Pengadaan
                          </div>
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Pengadaan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="form.date"
                                  
                                  v-on:keyup.enter="save()"
                                  
                                  
                                  outlined
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Tanggal Pengadaan"
            
                                  :disabled="Object.keys(form).length < 1"
                                  hide-details
                                
            
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>
                                    
                                    <div v-if="form.date !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <!-- <v-col>
                          <ValidationProvider 
                            name="Status Permintaan"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Status Permintaan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Status Permintaan"

                              hide-details

                              :items="[{
                                id: 'Draft',
                                name: 'Draft'
                              }, {
                                id: 'Menunggu',
                                name: 'Menunggu'
                              }]"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"

                              v-model="form.status"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.status !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col> -->
                        <!-- <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nomor Induk Pegawai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Nomor Induk Pegawai
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Contoh. 3102XXX"
                              
                              hide-details

                              v-model="form.nip"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.nip !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col> -->
                        <v-col>
                          <ValidationProvider 
                            name="Bagian"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
  
                              Bagian
                            </div>
  
                            <v-autocomplete
                              v-on:keyup.enter="save()"
  
                              outlined
                              rounded
                              dense
  
                              :color="set_color"
                              placeholder="Bagian"
  
                              hide-details
  
                              :items="location"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"
  
                              v-model="form.location_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.location_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <div class="d-flex px-2" style="width: 100%;">
                            <div class="fs-18 font-weight-bold black_one">
                              Data Item
                            </div>
  
                            <div class="ml-auto">
                              <v-btn
                                elevation="0"
                                @click="dialog.form = true; reset();"
                                color="#240087"
                                class="fs-12 white--text text-capitalize border-radius">
                                <v-icon
                                  size="20">
                                  mdi-plus
                                </v-icon>
  
                                <span
                                  class="ml-2">
                                  Tambah Item
                                </span>
                              </v-btn>
                            </div>
                          </div>

                          <v-card flat
                            v-if="form.items.length < 1">
                            <v-card-text
                              class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="90"
                                  :height="90"
                                  :src="require('@/assets/image/empty.png')">
                                  <!-- <template v-slot:placeholder>
                                    <v-row
                                      class=" "
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template> -->
                                </v-img>
                                <div class="mt-3 fs-18">
                                  Belum Ada Item
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>

                          <div class="mt-5" v-if="form.items.length > 0">
                            <div class="view mt-1">
                              <div class="">
                                <table style="border: 1px solid #ededed; width: 100%;" class="table">
                                  <tr>
                                    <th style="font-size: 14px; z-index: 1; width: 50px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Aksi</th>
                                    <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Akun</th>
                                    <th style="font-size: 14px; z-index: 1; width: 100px; min-width: 100px; max-width: 100px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Satuan</th>
                                    <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                      <div class="d-flex align-center">
                                        <div>
                                          Qty
                                        </div>
                                        <!-- <div class="ml-auto">
                                          {{ add_total_debit | price }}
                                        </div> -->
                                      </div>
                                    </th>
                                    <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                      <div class="d-flex align-center">
                                        <div>
                                          Catatan
                                        </div>
                                        <!-- <div class="ml-auto">
                                          {{ add_total_kredit | price }}
                                        </div> -->
                                      </div>
                                    </th>
                                  </tr>
                                  <tr v-for="(item, index) in form.items" :key="index" @click="selected.add = (((`100${index}`) + index) + (index+1))" :class="selected.add === (((`100${index}`) + index) + (index+1)) ? 'selected' : ''">
                                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 50px; min-width: 50px; max-width: 50px; text-align: center;">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            min-width="36"
                                            rounded
                                            @click="form.items.splice(index, 1);"
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon small>mdi-trash-can-outline</v-icon>
                                            
                                          </v-btn>
                                        </template>
                
                                        <span>Hapus</span>
                                      </v-tooltip>
                                    </td>
                                    <td style="font-size: 12px; border: 1px solid #ededed; width: 210px; min-width: 210px; max-width: 210px; border-left: none; padding: 8px 12px; text-align: left;">
                                      {{ item.name }}
                                    </td>
                                    <td style="font-size: 12px; border: 1px solid #ededed; width: 100px; min-width: 100px; max-width: 100px; border-left: none; padding: 8px 12px; text-align: left;">
                                      {{ item.satuan }}
                                    </td>
                                    <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                      <ValidationProvider
                                        :name="`qty ${item.name}`" 
                                        :rules="`min_value:0`" 
                                        v-slot="{ errors }">
                                        <v-currency-field
                                              
                                          
                                          rounded
                                          dense
                                          outlined
                                          hide-details
                    
                                          :color="set_color"
                                          placeholder="qty"
                                          :error-messages="errors"
                    
                                          v-model="item.qty"
                                          :auto-decimal-mode="false"
                                          :decimal-length="2"
                                          
                                          required
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                                            
                                            <!-- <div v-if="item.debit !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div> -->
                                          </template>
                                        </v-currency-field>
                                      </ValidationProvider>
                                    </td>
                                    <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 250px; min-width: 250px; max-width: 250px; padding: 8px 12px; text-align: right;">
                                      <v-textarea
                                        v-model="item.note_permintaan"
                                        outlined
                                        dense
                                        rows="2"
                                        :color="set_color"
                                        hide-details
                                        placeholder="Catatan"
                                        style="border-radius: 10px;">
                                      </v-textarea>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <!-- <div v-for="(item, index) in form.items" :key="index">
                              <v-card flat class="mb-5" style="    background: #f0f8ff80; border-radius: 10px; border: 1px solid #f1f1f1;">
                                <v-card-text>
                                  <div class="d-flex">
                                    <div>
                                      <div class="fs-16 font-weight-bold black_one">
                                        {{ item.name }}
                                      </div>
                                      <div>
                                        Kategori: <span class="font_weight_600">{{ item.category_item_name }}</span>
                                      </div>
                                      <div>
                                        Harga Beli: <span class="font_weight_600">{{ item.purchase_price | price }} / {{ item.satuan }}</span>
                                      </div>
                                      <v-img 
                                        v-if="item.image_url !== ''"
                                        class="mr-auto mt-2"
                                        contain
                                        alt="vuetify"
                                        :width="50"
                                        :height="50"
                                        :src="item.image_url">
                                      </v-img>
                                    </div>

                                    <div class="ml-auto text-right">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          
                                            @click="form.items.splice(index, 1); changeTotal()"

                                            v-bind="attrs"
                                            v-on="on"

                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            color="red"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0 mb-2"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                                          </v-btn>
                                        </template>
                                        
                                        <span>Hapus</span>
                                      </v-tooltip>

                                      
                                    </div>
                                    
                                  </div>

                                  <v-row class="mt-4">
                                    <v-col cols="4">
                                      <div>
                                        Harga Beli
                                      </div>
                                    </v-col>
                                    <v-col cols="4">
                                      <div>
                                        Quantity
                                      </div>
                                    </v-col>
                                    <v-col cols="4" class="text-right">
                                      <div>
                                        Total
                                      </div>
                                    </v-col>

                                    <v-col class="py-0" cols="4">
                                      <div class="fs-16 font_weight_600 black_one">
                                        {{ item.purchase_price | price }} / {{ item.satuan }}
                                      </div>
                                    </v-col>
                                    <v-col class="py-0" cols="4">
                                      <div>
                                        <ValidationProvider
                                          :name="`Quantity ${item.name}`" 
                                          :rules="`min_value:0`" 
                                          v-slot="{ errors }">
                                          <v-currency-field
                                                
                                            
                                            rounded
                                            dense
                                            outlined
                                            hide-details
                      
                                            color="#718EBF"
                                            placeholder="Qty"
                                            v-on:change="changeTotal()"
                                            :error-messages="errors"
                                            :suffix="`${item.satuan}`"

                                            
                      
                                            v-model="item.qty"
                                            
                                            required
                                            style="border-radius: 10px;">
                                            <template v-slot:append-outer>
                                              <div v-if="errors.length > 0">
                                                <v-tooltip top color="#ff5252">
                                                  <template v-slot:activator="{ on }">
                                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                  </template>
                                                  
                                                  {{ errors[0] }}
                                                </v-tooltip>
                                              </div>
                                              
                                              <div v-if="item.qty !== '' && valid">
                                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                                              </div>
                                            </template>
                                          </v-currency-field>
                                        </ValidationProvider>
                                      </div>
                                    </v-col>
                                    <v-col cols="4" class="py-0 text-right">
                                      <div class="fs-16 font_weight_600 black_one">
                                        {{ (item.qty*1) * (item.purchase_price*1) | price }}
                                      </div>
                                    </v-col>

                                    <v-col class="py-0" cols="4">
                                      <ValidationProvider 
                                        :name="`Supplier ${item.name}`"
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                                        <div class="mb-2">
                                          <span class="red--text">*</span>
                                          Supplier {{ item.name }}
                                        </div>
                                        <v-autocomplete
                                          v-on:keyup.enter="save()"
                                          v-on:change="changeHarga(index)"
                                          
                                          outlined
                                          rounded
                                          dense
                                          :color="set_color"
                                          placeholder="Pilih salah satu Supplier"
                                          hide-details
                                          clearable
                                          item-text="supplier_name"
                                          item-value="supplier_id"
                                          :items="item.supplier"
                                          v-model="item.supplier_id"
                                          class="mb-6"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
  
                                            <div v-if="item.supplier_id !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-autocomplete>
                                      </ValidationProvider>
                                    </v-col>

                                    <v-col class="py-0" cols="12">
                                      <div class="mb-2">
                                        Catatan
                                      </div>
                                      <v-textarea
                                        v-model="item.note_permintaan"
                                        outlined
                                        dense
                                        rows="2"
                                        placeholder="Catatan"
                                        style="border-radius: 10px;">
                                      </v-textarea>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </div>
                            <v-divider class="my-2"></v-divider>
                            <v-row>
                              <v-col>
                                <div class="fs-17 font_weight_600 text-left black_one">
                                  Total Perkiraan Modal Belanja
                                </div>
                              </v-col>
                              <v-col>
                                <div class="fs-17 font_weight_600 text-right black_one">
                                  {{ total_nominal | price }}
                                </div>
                              </v-col>
                            </v-row> -->
                          </div>

                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="#240087"
                class="body-2 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/pembelian/permintaan"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        item: [],

        dialog: {
          form: false,
          fullscreen: false
        
        },
        total_nominal: 0,
        tosearch: '',

        form: {
          outlet_id: '',
          location_id: '',

          date: '',
          status: 'Menunggu',
          items: []

        },
        selected_id: [],
        selected: [],
        menu2: false,
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,
          load: false,
          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetch()
      this.form.outlet_id = this.user.cat_title === 'Owner' ? this.outlet.outlet_id : this.outlet.outlet_id
    },
    methods: {
      async fetchDetail () {
        // this.process.load = true

        let params = {
          id: this.$store.state.user.id
        }

        await get(`pos/user/data`, { params })
        .then(response => {
          let res = response.data

          // this.process.load = false

          if (res.status === 200) {
            this.form.location_id = res.results.data[0].location_id === '0' ? '' : res.results.data[0].location_id
          }

          this.fetchBagian()
        })
      },
      async fetch () {
        this.process.load = true
        let params = {
          limit: 100000,
          outlet_id: this.outlet.outlet_id,
          search: this.tosearch
        }
        
        await get('pos/pembelian/item/data_last_child', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.item = []
            res.results.data.map((item) => {
              this.item.push({ 
                ...item,
                qty: 0,
                note_permintaan: '',
                total: 0,
                supplier_id: '',
                supplier: []
              })
            })
            this.process.load = false
            // this.item.map((item) => {
            //   this.fetchSupplier(item.id)
            // })
            // this.item = res.results.data
          }
        })
      },
      async fetchSupplier (id) {
        let params = {
          limit: 100000,
          item_id: id
        }
        
        await get('pos/pembelian/item_supplier/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            if(res.results.data.length > 0) {
              this.item.map((item) => {
                if(item.id === id) {
                  item.supplier = res.results.data
                }
              })
            }
          }
        })
      },
      changeTotal() {
        this.total_nominal = this.form.items.reduce((acc, item) => {
          return acc + (item.qty * item.purchase_price)
        }, 0)
      },
      changeHarga(index) {
        this.form.items[index].supplier.map((supplier) => {
          if(supplier.supplier_id === this.form.items[index].supplier_id) {
            this.form.items[index].purchase_price = supplier.purchase_price
            this.changeTotal()
          }
        })
      },

      async fetchBagian () {
        let params = {
          limit: 100000
        }
        
        await get('pos/location/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.location = res.results.data
          }
        })
      },
      reset () {
        this.selected = this.form.items
      },
      saveItem () {
        this.form.items = this.selected
        this.dialog.form = false
        this.tosearch = ''
        this.fetch()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`pos/pembelian/request/add`, {
            data: {
              ...this.form,
              items: JSON.stringify(this.form.items.map(item => {
              return {
                item_id: item.id,
                qty: item.qty,
                note: item.note_permintaan,
                supplier_id: item.supplier_id,
                purchase_price: item.purchase_price
              }
            }))
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/pembelian/permintaan' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style>
  table {
    border-collapse: collapse;
    width: 100%;
  }
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: rgb(36, 0, 135);
  }
  ::-webkit-scrollbar-track{
    background-color: rgb(36, 0, 135);
    border-radius: 10px;
  }
</style>